function Scroll() {
	var self = this;
	self.init();
}

Scroll.prototype.init = function() {
	var self = this;
	self.showMenuBarAfterScroll();
	self.handleParkselectorAfterScroll();
};

Scroll.prototype.showMenuBarAfterScroll = function() {
	var self = this;
	
	var didScroll;

	$(window).scroll(function(event){
		didScroll = true;
	});

	didScrollFn();

	function didScrollFn() {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
		requestAnimationFrame(didScrollFn);
	}

	if (!$('.banner').length) {
		didScroll = true;
		hasScrolled();
	}

	function hasScrolled() {
		if ($('.banner').length) {
			var scrollTop = $(this).scrollTop();
			var bannerHeight = $('.banner').outerHeight();
			var headerHeight = $('.header').outerHeight();
			if (scrollTop > headerHeight) {
				$('.header').addClass('-scrolled');
				if (scrollTop > 500) {
					$('.header').addClass('-transition');
				} else {
					$('.header').removeClass('-transition');
				}
				if (scrollTop > bannerHeight) {
					$('.header').addClass('-show');
				} else {
					$('.header').removeClass('-show');
				}
			} else {
				$('.header').removeClass('-scrolled');
			}
		} else {
			$('.header').addClass('-show').addClass('-scrolled');
		}
	}
};

Scroll.prototype.handleParkselectorAfterScroll = function() {
	var self = this;
	$(window).on('scroll', function() {
		var scrollTop = $(window).scrollTop();
		if (scrollTop > 0) {
			$('.parkselector').addClass('-scrolled');
		} else {
			$('.parkselector').removeClass('-scrolled');
		}
	});
};